import { render, staticRenderFns } from "./GlobalDashboardView.vue?vue&type=template&id=d302f8d6&scoped=true&"
import script from "./GlobalDashboardView.vue?vue&type=script&lang=ts&"
export * from "./GlobalDashboardView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d302f8d6",
  null
  
)

export default component.exports